// FILE: components/PatientIntake/PaymentInformation/PaymentInformation.tsx
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-promise-executor-return */
/* eslint-disable no-await-in-loop */
/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */

import './paymentInformation.css';

import MUISelectInput from '@brands/Components/Inputs/MuiSelectInput/MUISelectInput';
import TextField from '@brands/Components/Inputs/MuiTextField/TextField';
import MuiToggle from '@brands/Components/Inputs/MuiToggle/MuiToggle';
import { Loading } from '@brands/Components/LoadingSpinner/Loading';
import PatientIntakeNavigation from '@brands/Components/PatientIntakeNavigation/PatientIntakeNavigation';
import SubmitCCConfirmationModal from '@brands/Dashboard/Dashboard/DashboardModals/SubmitCCConfirmationModal';
import { priceFor } from '@brands/Dashboard/Dashboard/Patient/utils/helpers';
import {
  resolveBillingPostalCode,
  tokenizeAndVerifyBillingPostalCode,
  updateDataInsuranceNewDesign,
  updateDataPayment,
  updateDataSecondaryInsuranceNewDesign,
  UploadedFile,
} from '@brands/Dashboard/MyProfile/Patient/utils/utilsFunctions';
import { VerificationType } from '@brands/Dashboard/PatientForms/PatientForm/PaymentInformation/InsuranceModal/InsuranceVerificationModal';
import useRoleNavigate from '@brands/hooks/useRoleNavigate';
import { RegisterMediaPayload } from '@brands/services/communication/registersConversationMedia';
import { deactivateInsuranceById } from '@brands/services/identity/deactivatePatientInsurance';
import { getDependentById } from '@brands/services/identity/getDependentById';
import { getPricings, Pricings } from '@brands/services/identity/getPricings';
import { getPricingsByAdmin } from '@brands/services/identity/getPricingsByAdmin';
import { InsuranceMedia } from '@brands/services/identity/types/UserProfile';
import { updateMe } from '@brands/services/identity/updateMe';
import { verifyInsurance } from '@brands/services/identity/verifyInsurance';
import { verifyInsuranceByAdmin } from '@brands/services/identity/verifyInsuranceByAdmin';
import { confirmOneReportMedia } from '@brands/services/oneReport/confirmOneReportMedia';
import { getOneReportMedia } from '@brands/services/oneReport/getOneReportMedia';
import { registerOneReportMedia } from '@brands/services/oneReport/registerOneReportMedia';
import { selectAuth } from '@brands/store/selectors/auth';
import { selectLinkedCase } from '@brands/store/selectors/linkedCase';
import { selectOrganization } from '@brands/store/selectors/organization';
import { selectPatientForm } from '@brands/store/selectors/patientForm';
import { selectPatientMyProfile } from '@brands/store/selectors/patientMyProfile';
import { selectPatient } from '@brands/store/selectors/selectedPatient';
import { setUser } from '@brands/store/slices/authSlice';
import { addFormItem, setForm } from '@brands/store/slices/patientFormSlice';
import { setPatientMyProfile } from '@brands/store/slices/patientMyProfileSlice';
import { base64ListToFileList } from '@brands/Utils/base64ToFile';
import { lastAmount } from '@brands/Utils/needsPayment';
import LinkedCareCoordinationRedirect from '@brands/Dashboard/MultiStage/LinkedCareCoordinationRedirect';
import { getFileMimeType } from '@brands/Utils/truncateString';
import { yupResolver } from '@hookform/resolvers/yup';
import { Button, FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { heicTo } from 'heic-to';
import moment from 'moment';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { isMobile as mobileDetect } from 'react-device-detect';
import { useForm } from 'react-hook-form';
import { AiOutlineLeft } from 'react-icons/ai';
import { FiMinus, FiPlus } from 'react-icons/fi';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import Container from '../../../../Components/Container/Container';
import { config } from '../../../../config/config';
import { useInsuranceCarriers, useStepUrl } from '../../../../hooks';
import { useAppDispatch, useAppSelector } from '../../../../hooks/useReduxHook';
import useWindowSize from '../../../../hooks/useWindowSize';
import { CaseType } from '../../../../services/cases/types/ICase';
import { addPaymentProfile } from '../../../../services/identity/addPaymentProfile';
import { createPatientInsurance } from '../../../../services/identity/createPatientInsurance';
import { getPatientInsurance } from '../../../../services/identity/getPatientInsurance';
import { PaymentProfile } from '../../../../services/identity/types/PaymentProfile';
import { Address, Insurance, UserRoleName } from '../../../../services/identity/types/UserProfile';
import { displayErrorDetails } from '../../../../Utils/displayError';
import { getCaseDisclaimer } from '../../../../Utils/getFriendlyName';
import { getSecondaryColor } from '../../../../Utils/getPrimaryColor';
import { stateOptions } from '../../../../Utils/selectOptions';
import InsuranceFormSection from '../../../Insurance/InsuranceFormSection';
import { InsuranceImages, InsuranceMediaContent } from '../../../Insurance/utils/types';
import { PatientFormFiveSubmit } from '../utils/types';
import amex from './assets/AMEX.svg';
import disCover from './assets/DisCover.svg';
import fsa from './assets/FSA.svg';
import hsa from './assets/HSA.svg';
import jcb from './assets/JCB.svg';
import masterCard from './assets/Mastercard.svg';
import unionPay from './assets/UnionPay.svg';
import visa from './assets/Visa.svg';
import InsuranceVerificationModal from './InsuranceModal/InsuranceVerificationModal';
import styles from './styles.module.scss';
import { validationSchema } from './utils/validationSchema';

const billingAddressOptions = ['Current address', 'Use a different billing address'];

const { locationId } = config.square;
const appId = config.square.applicationId;

type Card = {
  attach: (containerId: string) => Promise<any>;
  tokenize: () => Promise<{
    token: string;
    status: string;
    errors?: JSON;
    details?: { card: any; method: string; billing: any };
  }>;
  status: number;
  addEventListener: (eventName: string, callback: () => void) => void;
};

type IntakePaymentLocationState = {
  afterPaymentRoute?: string;
  caseType?: string;
  userOrganization?: string;
  patientId?: number;
  patientState?: string;
  // Carries a reschedule of a pre-existing case (e.g. a linked multi-stage
  // case being scheduled for the first time) through to ConfirmPayment,
  // which otherwise has no other way to know to PATCH the existing case
  // instead of POSTing a new one — this flow never visits SelectCaseType,
  // so form_question_id 20 is never set in the intake form either.
  RescheduleCase?: boolean;
  caseId?: number;
};

const PaymentInformation = (): JSX.Element => {
  const { linkedCaseId } = useAppSelector(selectLinkedCase);
  const { values } = useAppSelector(selectPatientForm);
  const { state } = useLocation();
  const caseType =
    (values.find((item) => item.form_question_id === 20)?.value.caseType as string) || state?.caseType || '';

  // Mount the form (including Square's effects) only after checkout is allowed.
  return (
    <LinkedCareCoordinationRedirect caseId={caseType === CaseType.care_coordination ? linkedCaseId : null}>
      <PaymentInformationForm />
    </LinkedCareCoordinationRedirect>
  );
};

const PaymentInformationForm = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const roleNavigate = useRoleNavigate();
  const location = useLocation();

  const paymentPassThroughState = useMemo((): IntakePaymentLocationState => {
    const s = (location.state ?? {}) as IntakePaymentLocationState;
    return {
      afterPaymentRoute: s.afterPaymentRoute,
      caseType: s.caseType,
      userOrganization: s.userOrganization,
      patientId: s.patientId,
      patientState: s.patientState,
      RescheduleCase: s.RescheduleCase,
      caseId: s.caseId,
    };
  }, [location.state]);

  const intakeContinueStateForModal = useMemo(
    () => ({
      caseType: paymentPassThroughState.caseType,
      userOrganization: paymentPassThroughState.userOrganization,
      patientId: paymentPassThroughState.patientId,
      patientState: paymentPassThroughState.patientState,
      RescheduleCase: paymentPassThroughState.RescheduleCase,
      caseId: paymentPassThroughState.caseId,
    }),
    [
      paymentPassThroughState.caseType,
      paymentPassThroughState.userOrganization,
      paymentPassThroughState.patientId,
      paymentPassThroughState.patientState,
      paymentPassThroughState.RescheduleCase,
      paymentPassThroughState.caseId,
    ],
  );

  const screenSize = useWindowSize();
  const isMobile = screenSize.width < 768;

  const [card, setCard] = useState<Card>();
  const [isDragging, setIsDragging] = useState(false);
  const [isSameAddress, setIsSameAddress] = useState(false);
  const [loading, setLoading] = useState(false);
  const [savedVerificationCode, setSavedVerificationCode] = useState('');
  const { currentOrganization } = useAppSelector(selectOrganization);
  const [currentOrganizationPrices, setCurrentOrganizationPrices] = useState<Pricings[]>([]);

  const [disablePaymentButton, setDisablePaymentButton] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState('');
  const [paymentMethod, setPaymentMethod] = useState<string>('');
  const [billingAddress, setBillingAddress] = useState<string>('');
  const [displaypaymentOption, setDisplayPaymentOption] = useState('');

  // Reflect the active payment-method form as a unique URL so analytics can
  // track drop-offs per payment method. Mirrors the rendered panel below.
  let paymentStep: string | null = null;
  if (displaypaymentOption !== '' && paymentMethod === 'Pay with insurance') {
    paymentStep = 'insurance';
  } else if (displaypaymentOption !== '' && paymentMethod === 'Self pay') {
    paymentStep = 'self-pay';
  }
  useStepUrl('payment-information', paymentStep);

  const patientValues = useAppSelector(selectPatientMyProfile);
  const { values, selectedPatient } = useAppSelector(selectPatientForm);
  const { selectedPatient: currentPatient } = useAppSelector(selectPatient);
  const { userInfo } = useAppSelector(selectAuth);
  const { linkedCaseId, linkedCaseNeedsPayment } = useAppSelector(selectLinkedCase);
  const isStaffPatientFlow =
    userInfo.role.name === UserRoleName.Admin ||
    userInfo.role.name === UserRoleName.SuperAdmin ||
    userInfo.role.name === UserRoleName.OrganizationAdmin ||
    userInfo.role.name === UserRoleName.Collector ||
    userInfo.role.name === UserRoleName.CareAdvisor;
  const [collectTargetUserError, setCollectTargetUserError] = useState('');

  const phoneInputRef = useRef<HTMLInputElement>(null);
  const insuranceCarriers = useInsuranceCarriers();

  const [currentPatientInsurance, setCurrentPatientInsurance] = useState<Insurance[]>([]);

  const hasSecondaryInsurance = currentPatientInsurance?.some((i) => i.is_secondary) ?? false;
  const [addSecondaryInsurance, setAddSecondaryInsurance] = useState<boolean>(hasSecondaryInsurance);
  const [isOtherCarrierIdIsSelected, setIsOtherCarrierIdIsSelected] = useState(false);
  const [pricesFetched, setPricesFetched] = useState(false);

  const insuranceCarrierOptions = useMemo(() => {
    return insuranceCarriers.map((insuranceCarrier) => ({
      value: insuranceCarrier.id,
      label: insuranceCarrier.name,
    }));
  }, [insuranceCarriers]);

  const cardContainerRef = useRef<HTMLDivElement | null>(null);
  const otherInsuranceId = useMemo(() => {
    return insuranceCarriers.length > 0 ? Math.max(...insuranceCarriers.map((carrier) => carrier.id)) + 1 : 1;
  }, [insuranceCarriers]);

  const [images, setImages] = useState<InsuranceImages>({
    front_of_card: [],
    back_of_card: [],
    secondary_front_of_card: [],
    secondary_back_of_card: [],
  });

  const checkAllowAddingPaymentOrofileId = (): boolean => {
    const blockedVerificationTypes: VerificationType[] = [
      'notCovered_No',
      'notCovered_Unsure',
      'invalid_No',
      'invalid_Unsure',
    ];

    const isInvalidVerification =
      !!savedVerificationCode && blockedVerificationTypes.includes(savedVerificationCode as VerificationType);

    const caseType = (values.find((item) => item.form_question_id === 20)?.value.caseType as string) || '';

    const p = priceFor(currentOrganizationPrices, caseType as CaseType);

    const shouldHideSelfPay = p?.payment_options?.length === 1 && p.payment_options.includes('Insurance');

    const shouldBlockSelfPay = isInvalidVerification || shouldHideSelfPay;

    return shouldBlockSelfPay;
  };

  const [patientForm, setPatientForm] = useState<PatientFormFiveSubmit>(
    patientValues.myProfile.patientId === userInfo.id
      ? (patientValues.myProfile as PatientFormFiveSubmit)
      : ({
          member_id: '',
          group_number: '',
          insurance_through: '',
          insurance_carrier_id: 0,
          insurance_first_name: '',
          insurance_date_of_birth: '',
          insurance_gender: '',
          insurance_last_name: '',
          insurance_address1: '',
          insurance_address2: '',
          insurance_zip_code1: '',
          insurance_state1: '',
          insurance_city1: '',
          insurance_phone_number: '',
          other_insurance_name: '',
          secondary_member_id: '',
          secondary_group_number: '',
          secondary_insurance_through: '',
          secondary_insurance_carrier_id: 0,
          secondary_insurance_phone_number: '',
          secondary_insurance_first_name: '',
          secondary_insurance_date_of_birth: '',
          secondary_insurance_gender: '',
          secondary_insurance_last_name: '',
          secondary_insurance_address1: '',
          secondary_insurance_address2: '',
          secondary_insurance_state1: '',
          secondary_insurance_city1: '',
          secondary_insurance_zip_code1: '',
          secondary_insurance_address: '',
          secondary_insurance_city: '',
          secondary_insurance_state: '',
          secondary_insurance_zip_code: '',
          creditCardFullName: '',
          creditCardNumber: '',
          creditCardAddress1: '',
          creditCardAddress2: '',
          expiryDate: '',
          creditCardZipCode: '',
          cvvNumber: '',
          creditCardState: '',
          creditCardCity: '',
        } as PatientFormFiveSubmit),
  );

  const [dependentAddress, setDependentAddress] = useState<Address>(
    userInfo.role.name === UserRoleName.Patient
      ? userInfo.address
      : (isStaffPatientFlow && currentPatient?.address) || ({} as Address),
  );

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    clearErrors,
    watch,
    formState: { errors },
  } = useForm<PatientFormFiveSubmit>({
    mode: 'onChange',
    resolver: yupResolver(
      validationSchema(patientForm, paymentMethod, addSecondaryInsurance, isSameAddress, isOtherCarrierIdIsSelected),
    ),
  });

  const caseTypeValue = values.find((item) => item.form_question_id === 20)?.value.caseType as string;

  const navigateAfterPaymentSave = useCallback(
    (verificationType?: VerificationType): void => {
      if (paymentPassThroughState.afterPaymentRoute) {
        roleNavigate(paymentPassThroughState.afterPaymentRoute, {
          state: { ...intakeContinueStateForModal, verificationType },
        });
        return;
      }
      roleNavigate('/confirm-payment', {
        state: {
          verificationType,
          caseType: paymentPassThroughState.caseType,
          RescheduleCase: paymentPassThroughState.RescheduleCase,
          caseId: paymentPassThroughState.caseId,
        },
      });
    },
    [
      intakeContinueStateForModal,
      paymentPassThroughState.afterPaymentRoute,
      paymentPassThroughState.caseType,
      paymentPassThroughState.RescheduleCase,
      paymentPassThroughState.caseId,
      roleNavigate,
    ],
  );

  const casePricing = currentOrganizationPrices?.find((p: Pricings) => p.case_types.includes(caseTypeValue));
  const caseSupportsSelfPay = !!casePricing?.payment_options?.includes('Credit Card');

  const casePrice = lastAmount(casePricing);

  // casePrice === 0 here just means the org has no configured pricing entry
  // for this case type — not that this specific linked case is free.
  // linkedCaseNeedsPayment is the case's own ground truth
  // (upcoming_payment_required); trusting casePrice over it forces the
  // patient into insurance-only mode for a case that genuinely still owes
  // payment, and self-pay never gets collected.
  const shouldActivateOnlyPayByInsurance =
    casePrice === 0 && currentOrganization.collect_insurance_info && !linkedCaseNeedsPayment;

  const isAlreadyFree = casePricing?.amount === 0;

  const isUnlimited = (casePricing?.plan_decision_reason || '').toUpperCase() === 'UNLIMITED';
  const creditsRemaining = isUnlimited ? Infinity : casePricing?.plan_free_remaining ?? 0;
  const eligibleByPlan = !!casePricing && casePricing.amount_after_plan === 0 && (isUnlimited || creditsRemaining > 0);

  // Gated off entirely for a linked case being completed — submitLinkedCase()
  // in ConfirmPayment.tsx only knows how to attach a saved card
  // (updatePaymentProfile) or insurance (updateCaseInsurance) to an existing
  // case; there's no PATCH-based equivalent yet for "pay with plan credits"
  // (that only exists as part of the brand-new-case POST /cases payload), so
  // letting a linked-case patient pick it would silently submit with no
  // payment attached at all.
  const canShowCredits = eligibleByPlan && !isAlreadyFree && !linkedCaseId;

  const CREDITS_OPTION = 'Pay with plan credits' as const;
  const afterThisService = creditsRemaining === Infinity ? '∞' : Math.max((creditsRemaining as number) - 1, 0);

  // ---------- Disable logic ----------
  const pricing = currentOrganizationPrices?.find((p: Pricings) => p.case_types.includes(caseTypeValue));

  const allowsInsurance = pricing?.payment_options?.includes('Insurance') ?? false;
  const allowsSelfPay = pricing?.payment_options?.includes('Credit Card') ?? false;

  // Care Coordination and Second Opinion are Self-payable regardless of
  // the pricing.payment_options config — the submit handler below already
  // carves them out explicitly (see the `Self pay` branch around the
  // subscribing commit's line ~1067). Mirror that here so the UI actually
  // offers Self pay; otherwise with only `Pay with insurance` enabled the
  // single-option-auto-select effect collapses the option UI and sends
  // the user straight to the insurance form (DO-3970). The carve-out has
  // to run before the `shouldActivateOnlyPayByInsurance` block below,
  // because that block (free case + org.collect_insurance_info) would
  // otherwise return `true` for 'Self pay' and make the carve-out
  // unreachable.
  //
  // Same problem, different trigger: completing an upcoming LINKED case
  // (any case type) whose org has no configured payment_options for that
  // type — e.g. a linked video_call_scheduled case — hits this exact trap
  // too. linkedCaseNeedsPayment is the case's own backend-reported
  // CaseIntakeState.upcoming_payment_required (ground truth, not org
  // pricing config), set by completeLinkedCase.ts's
  // startLinkedCaseCompletion.
  const selfPayAllowedForCaseType =
    caseTypeValue === CaseType.second_opinion ||
    caseTypeValue === CaseType.care_coordination ||
    linkedCaseNeedsPayment;

  const isPaymentOptionDisabled = (element: string): boolean => {
    if (element === CREDITS_OPTION) return !canShowCredits;

    if (element === 'Self pay' && selfPayAllowedForCaseType) return false;

    if (shouldActivateOnlyPayByInsurance) {
      return element !== 'Pay with insurance';
    }

    if (element === 'Pay with insurance') return !allowsInsurance;
    if (element === 'Self pay') return !allowsSelfPay;

    return true;
  };

  const options = [...(canShowCredits ? [CREDITS_OPTION] : []), 'Pay with insurance', 'Self pay'];

  const enabledOptions = options.filter((opt) => !isPaymentOptionDisabled(opt));

  const removeSecondaryInsurance = async (secondaryInsuranceId: number): Promise<void> => {
    try {
      await deactivateInsuranceById(secondaryInsuranceId);
      fetchUserInsurance();
    } catch (error: unknown) {
      displayErrorDetails(error);
    }
  };

  useEffect(() => {
    if (!pricesFetched) return;

    if (enabledOptions.length === 1) {
      if (paymentMethod !== enabledOptions[0]) setPaymentMethod(enabledOptions[0]);
      if (displaypaymentOption !== enabledOptions[0]) setDisplayPaymentOption(enabledOptions[0]);
    } else {
      if (paymentMethod !== '') setPaymentMethod('');
      if (displaypaymentOption !== '') setDisplayPaymentOption('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pricesFetched, enabledOptions.length, canShowCredits, shouldActivateOnlyPayByInsurance, isAlreadyFree]);

  useEffect(() => {
    const fetchDependentAddress = async (): Promise<void> => {
      const selectedId = Number(selectedPatient?.value);
      if (!selectedId) return;

      const isPatientManagingOther = userInfo.role.name === UserRoleName.Patient && userInfo.id !== selectedId;
      const isStaffViewingDependent =
        isStaffPatientFlow && currentPatient.guardian_id != null && !Number.isNaN(Number(currentPatient.guardian_id));

      if (!isPatientManagingOther && !isStaffViewingDependent) {
        return;
      }

      try {
        const parentUserId =
          userInfo.role.name === UserRoleName.Patient ? Number(userInfo.id) : Number(currentPatient.guardian_id);
        if (!parentUserId) {
          return;
        }
        const dependent = await getDependentById(parentUserId, selectedId, userInfo.role.name);
        setDependentAddress(dependent.address);
      } catch (error: unknown) {
        displayErrorDetails(error);
        if (currentPatient?.address) {
          setDependentAddress(currentPatient.address);
        }
      }
    };
    const fetchOrganizationPrices = async (): Promise<void> => {
      if (selectedPatient?.value) {
        const patientId = Number(selectedPatient.value);
        const orgId = currentOrganization?.id || config.organization_id || 'dentistry-one';
        const prices = isStaffPatientFlow
          ? await getPricingsByAdmin(patientId, orgId, { userRole: userInfo.role.name })
          : await getPricings(selectedPatient.value);
        setCurrentOrganizationPrices(prices);
      }
      setPricesFetched(true);
    };
    fetchOrganizationPrices();
    if (selectedPatient?.value && userInfo.id !== selectedPatient?.value) fetchDependentAddress();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPatient, currentOrganization?.id, userInfo.role.name]);

  useEffect(() => {
    if (userInfo.role.name === UserRoleName.Collector && currentPatient?.id) {
      setCollectTargetUserError('');
    }
  }, [currentPatient?.id, userInfo.role.name]);

  const addImages = (files: File[], type: keyof InsuranceImages): void => {
    const newImages = files.filter(
      (file) =>
        file.type.startsWith('image/') ||
        file.type === 'application/pdf' ||
        file.type === 'application/msword' ||
        file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
        file.type === 'application/vnd.ms-powerpoint' ||
        file.type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    );
    if (getValues(type).length + files.length > 10) {
      displayErrorDetails('Max 10 files are allowed to upload.');
      return;
    }
    const imagesArray: UploadedFile[] = [];
    for (let i = 0; i < newImages.length; i++) {
      const file = newImages[i];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.addEventListener('load', () => {
        imagesArray.push({ name: file.name, dataURL: reader.result as string });
        if (imagesArray.length === newImages.length) {
          setValue(type, imagesArray, { shouldValidate: true });
          setImages({
            ...images,
            [type]: imagesArray,
          });
        }
      });
    }
  };

  const deleteMedia = (mediaName: string, type: keyof InsuranceImages): void => {
    const selectedMedia = getValues(type).find((image) => image.name === mediaName);
    if (selectedMedia) {
      setValue(
        type,
        getValues(type).filter((image) => image.name !== mediaName),
        { shouldValidate: true },
      );
      setImages({ ...images, [type]: images[type].filter((image) => image.name !== mediaName) });
    }
  };

  const handleChange = async (event: React.ChangeEvent<HTMLInputElement>): Promise<void> => {
    const files = Array.from(event.target.files as unknown as File[]);
    const convertedFiles = await Promise.all(
      files.map(async (file) => {
        if (file.type === 'image/heic') {
          try {
            const jpegBlob = await heicTo({ blob: file, type: 'image/jpeg', quality: 0.85 });
            return new File([jpegBlob], file.name.replace(/\.heic$/i, '.jpeg'), { type: 'image/jpeg' });
          } catch (error: any) {
            displayErrorDetails(`Error converting HEIC to JPEG: ${error}`);
            return file;
          }
        }
        return file;
      }),
    );
    addImages(convertedFiles, event.target.id as keyof InsuranceImages);
  };

  const handleDragOver = (event: React.DragEvent<HTMLDivElement>): void => {
    event.preventDefault();
    event.stopPropagation();
  };

  const handleDrop = async (event: React.DragEvent<HTMLDivElement>, type: keyof InsuranceImages): Promise<void> => {
    event.preventDefault();
    setIsDragging(false);

    if (!event.dataTransfer.files?.length) return;
    let file = event.dataTransfer.files[0];

    if (file.type === 'image/heic') {
      try {
        const jpegBlob = await heicTo({
          blob: file,
          type: 'image/jpeg',
          quality: 0.85,
        });
        file = new File([jpegBlob], file.name.replace(/\.heic$/i, '.jpeg'), {
          type: 'image/jpeg',
        });
      } catch (error: any) {
        displayErrorDetails(`Error converting HEIC to JPEG: ${error}`);
      }
    }

    addImages([file], type);
  };

  const handleDragEnter = (event: React.DragEvent<HTMLDivElement>): void => {
    event.preventDefault();
    event.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (event: React.DragEvent<HTMLDivElement>): void => {
    event.preventDefault();
    event.stopPropagation();
    setIsDragging(false);
  };

  const loadImages = async (media_list: InsuranceMedia[]): Promise<InsuranceMediaContent[]> => {
    const imagePromises = media_list.map(async (mediaOneReport: InsuranceMedia) => {
      const mediaData = await getOneReportMedia(mediaOneReport.media_id!);
      return {
        src: mediaData.url,
        width: 4,
        height: 3,
        type: mediaOneReport.type,
        dataURL: mediaData.url,
        media_id: mediaOneReport.media_id,
        name: mediaData.filename,
      } as InsuranceMediaContent;
    });
    const imagesList = await Promise.all(imagePromises);
    return imagesList;
  };
  const fetchUserInsurance = async (): Promise<void> => {
    let userInsurance = [];
    userInsurance = await getPatientInsurance(Number(selectedPatient?.value));
    const primaryInsurance = userInsurance.find((i) => !i.is_secondary) || null;
    const secondaryInsurance = userInsurance.find((i) => i.is_secondary) || null;
    if (userInsurance.length > 0) {
      const imagesObj: InsuranceImages = {
        front_of_card: [],
        back_of_card: [],
        secondary_front_of_card: [],
        secondary_back_of_card: [],
      };

      if (primaryInsurance) {
        for (const key of Object.keys(primaryInsurance)) {
          if (key === 'media') {
            const media = primaryInsurance[key];
            const frontOfCard = media?.filter((mediaItem) => mediaItem.type === 'front_of_card');
            const backOfCard = media?.filter((mediaItem) => mediaItem.type === 'back_of_card');
            if (frontOfCard || backOfCard) {
              const mediaList = [...(frontOfCard || []), ...(backOfCard || [])];
              const medias = await loadImages(mediaList);
              imagesObj.front_of_card = medias.filter((image) => image.type === 'front_of_card');
              imagesObj.back_of_card = medias.filter((image) => image.type === 'back_of_card');
            }
          }
        }
      }
      if (secondaryInsurance) {
        for (const key of Object.keys(secondaryInsurance)) {
          if (key === 'media') {
            const media = secondaryInsurance[key];
            const frontOfCard = media?.filter((mediaItem) => mediaItem.type === 'front_of_card');
            const backOfCard = media?.filter((mediaItem) => mediaItem.type === 'back_of_card');
            if (frontOfCard || backOfCard) {
              const mediaList = [...(frontOfCard || []), ...(backOfCard || [])];
              const medias = await loadImages(mediaList);
              imagesObj.secondary_front_of_card = medias.filter((image) => image.type === 'front_of_card');
              imagesObj.secondary_back_of_card = medias.filter((image) => image.type === 'back_of_card');
            }
          }
        }
        setAddSecondaryInsurance(true);
      }
      setImages(imagesObj);
      setValue('front_of_card', imagesObj.front_of_card);
      setValue('back_of_card', imagesObj.back_of_card);
      setValue('secondary_front_of_card', imagesObj.secondary_front_of_card);
      setValue('secondary_back_of_card', imagesObj.secondary_back_of_card);
    }
    setCurrentPatientInsurance(userInsurance);
    setAddSecondaryInsurance(!!userInsurance.find((i) => i.is_secondary));

    setPatientForm({
      ...patientForm,

      /* ---------- PRIMARY ---------- */
      insurance_through: primaryInsurance?.insured_by || '',
      insurance_carrier_id: primaryInsurance?.insurance_membership?.insurance_carrier_id || 0,
      member_id: primaryInsurance?.insurance_membership?.member_id || '',
      group_number: primaryInsurance?.insurance_membership?.group_number || '',
      insurance_phone_number: primaryInsurance?.insurance_membership?.phone_number || '',

      insurance_first_name: primaryInsurance?.insurance_through?.first_name || '',
      insurance_last_name: primaryInsurance?.insurance_through?.last_name || '',
      insurance_gender: primaryInsurance?.insurance_through?.gender_identity || '',

      insurance_date_of_birth: primaryInsurance?.insurance_through?.date_of_birth
        ? moment(primaryInsurance.insurance_through.date_of_birth).format('MM/DD/YYYY')
        : '',

      insurance_address1: primaryInsurance?.insurance_through?.address?.address1 || '',
      insurance_address2: primaryInsurance?.insurance_through?.address?.address2 || '',
      insurance_city1: primaryInsurance?.insurance_through?.address?.city || '',
      insurance_state1: primaryInsurance?.insurance_through?.address?.state || '',
      insurance_zip_code1: primaryInsurance?.insurance_through?.address?.zip_code || '',

      insurance_address: primaryInsurance?.insurance_membership?.address?.address1 || '',
      insurance_city: primaryInsurance?.insurance_membership?.address?.city || '',
      insurance_state: primaryInsurance?.insurance_membership?.address?.state || '',
      insurance_zip_code: primaryInsurance?.insurance_membership?.address?.zip_code || '',

      state_funded_coverage_status: primaryInsurance?.state_funded_coverage_status || '',

      /* ---------- SECONDARY ---------- */
      secondary_insurance_through: secondaryInsurance?.insured_by || 'none',

      secondary_insurance_carrier_id: secondaryInsurance?.insurance_membership?.insurance_carrier_id || 0,

      secondary_member_id: secondaryInsurance?.insurance_membership?.member_id || '',
      secondary_group_number: secondaryInsurance?.insurance_membership?.group_number || '',
      secondary_insurance_phone_number: secondaryInsurance?.insurance_membership?.phone_number || '',

      secondary_insurance_first_name: secondaryInsurance?.insurance_through?.first_name || '',
      secondary_insurance_last_name: secondaryInsurance?.insurance_through?.last_name || '',
      secondary_insurance_gender: secondaryInsurance?.insurance_through?.gender_identity || '',

      secondary_insurance_date_of_birth: secondaryInsurance?.insurance_through?.date_of_birth
        ? moment(secondaryInsurance.insurance_through.date_of_birth).format('MM/DD/YYYY')
        : '',

      secondary_insurance_address: secondaryInsurance?.insurance_membership?.address?.address1 || '',
      secondary_insurance_city: secondaryInsurance?.insurance_membership?.address?.city || '',
      secondary_insurance_state: secondaryInsurance?.insurance_membership?.address?.state || '',
      secondary_insurance_zip_code: secondaryInsurance?.insurance_membership?.address?.zip_code || '',

      secondary_insurance_address1: secondaryInsurance?.insurance_through?.address?.address1 || '',
      secondary_insurance_address2: secondaryInsurance?.insurance_through?.address?.address2 || '',
      secondary_insurance_city1: secondaryInsurance?.insurance_through?.address?.city || '',
      secondary_insurance_state1: secondaryInsurance?.insurance_through?.address?.state || '',
      secondary_insurance_zip_code1: secondaryInsurance?.insurance_through?.address?.zip_code || '',
    });
  };
  useEffect(() => {
    fetchUserInsurance();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onInvalid = (e: any): void => {
    const error = Object.values(e)[0] as any;
    if (error) {
      toast.error(error.message as string);
    }
  };

  useEffect(() => {
    setIsOtherCarrierIdIsSelected(Number(getValues('insurance_carrier_id')) === otherInsuranceId);
  }, [getValues('insurance_carrier_id')]);

  useEffect(() => {
    Object.keys(patientForm).forEach((key: unknown) => {
      setValue(key as keyof PatientFormFiveSubmit, patientForm[key as keyof PatientFormFiveSubmit]);
    });
    const selectedCarrierId = values.find((item) => item.form_question_id === 14)?.value?.selectedCarrier;
    if (selectedCarrierId !== undefined && Number(selectedCarrierId) !== 0) {
      setValue('insurance_carrier_id', Number(selectedCarrierId));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patientForm]);

  const callAddOtherCarrierIdIsSelected = async (): Promise<void> => {
    if (isOtherCarrierIdIsSelected && getValues('other_insurance_name') !== '') {
      await updateMe(
        {
          other_insurance_name: getValues('other_insurance_name'),
        },
        userInfo.id,
      );
    }
    setShowInsuranceModal({ isOpen: false, verificationType: '' });
    setPaymentMethod('Self pay');
    setDisplayPaymentOption('Self pay');
    setDisablePaymentButton(false);
    setLoading(false);
  };

  const testInsuranceVerification = async (
    dataWithUpdatedInsurance: Insurance,
    dataWithUpdatedSecondaryInsurance?: Insurance,
    insuranceId?: number,
    secondaryInsuranceId?: number,
    q19BaseValue?: Record<string, unknown>,
  ): Promise<void> => {
    setLoading(true);
    setShowInsuranceModal({ isOpen: true, verificationType: 'verify' });
    await new Promise((resolve) => setTimeout(resolve, 200));
    let result: 'valid' | 'invalid' | 'notCovered' = 'invalid';
    let usedInsuranceId: number | undefined;
    if (isOtherCarrierIdIsSelected) {
      setSavedVerificationCode('notCovered_No');
      setShowInsuranceModal({ isOpen: true, verificationType: 'notCovered_No' });
    } else {
      const medicaidAnswer = dataWithUpdatedInsurance.state_funded_coverage_status; // 'yes' | 'no' | 'not_sure'

      const verifyWith = async (insurance: Insurance): Promise<void> => {
        const payerId = insurance.insurance_membership?.insurance_carrier_id;
        if (userInfo.role.name === UserRoleName.Patient) {
          await verifyInsurance({
            payer_id: payerId?.toString() || '',
            member_id: insurance.insurance_membership?.member_id as string,
            group_number: insurance.insurance_membership?.group_number as string,
            insured_by: insurance.insured_by,
            user_id: currentPatient.id,
          });
        } else {
          await verifyInsuranceByAdmin({
            user_id: currentPatient.guardian_id ?? currentPatient.id,
            payer_id: payerId?.toString() || '',
            member_id: insurance.insurance_membership?.member_id as string,
            group_number: insurance.insurance_membership?.group_number as string,
            insured_by: insurance.insured_by,
            userRole: userInfo.role.name,
          });
        }
      };

      try {
        // First hit to the BE: verify the primary insurance.
        await verifyWith(dataWithUpdatedInsurance);
        result = 'valid';
        usedInsuranceId = insuranceId;
      } catch (error: any) {
        if (addSecondaryInsurance && dataWithUpdatedSecondaryInsurance) {
          try {
            // Primary failed — hit the BE a second time with the secondary insurance.
            await verifyWith(dataWithUpdatedSecondaryInsurance);
            result = 'valid';
            usedInsuranceId = secondaryInsuranceId;
          } catch (secondaryError: any) {
            if (secondaryError?.response?.data?.error_code === 'PAYER_NOT_SUPPORTED') {
              result = 'notCovered';
            } else {
              result = 'invalid';
            }
          }
        } else if (error?.response?.data?.error_code === 'PAYER_NOT_SUPPORTED') {
          result = 'notCovered';
        } else {
          result = 'invalid';
        }
      }
      setLoading(false);

      if (result === 'valid' && usedInsuranceId) {
        // Merge onto the value just written by onSubmit's setForm dispatch, not the
        // component's `values` selector — that closure is a render-time snapshot and is
        // stale here (Redux applied the setForm dispatch synchronously, but this
        // function's `values` won't reflect it until the next render). Using the stale
        // value would wipe out insuranceId/paymentId/secondaryInsuranceId that were just set.
        dispatch(
          addFormItem({
            form_question_id: 19,
            value: { ...q19BaseValue, usedInsuranceId },
          }),
        );
      }

      const verificationTypeMap: Record<string, VerificationType> = {
        notCovered_yes: 'notCovered_Yes',
        notCovered_no: 'notCovered_No',
        notCovered_not_sure: 'notCovered_Unsure',
        invalid_yes: 'invalid_Yes',
        invalid_no: 'invalid_No',
        invalid_not_sure: 'invalid_Unsure',
        valid_yes: 'valid_Yes',
        valid_no: 'valid_No',
        valid_not_sure: 'valid_Unsure',
      };
      const key = `${result}_${medicaidAnswer}` as keyof typeof verificationTypeMap;
      const verificationType = verificationTypeMap[key];
      setSavedVerificationCode(verificationType);
      setShowInsuranceModal({ isOpen: true, verificationType });
    }
  };

  const uploadMedia = async (imagesValue: UploadedFile[] | undefined | null): Promise<string[]> => {
    if (!Array.isArray(imagesValue)) {
      console.error('uploadMedia received non-array:', imagesValue);
      return [];
    }
    let imageList: string[] = [];
    const newUploadedImages = imagesValue.filter((image) => image.dataURL.startsWith('data:'));
    const existingImages = imagesValue.filter((image) => image.dataURL.startsWith('https://'));
    if (newUploadedImages.length > 0) {
      imageList = newUploadedImages.map((image) => {
        if (typeof image === 'string') return image;
        return image.dataURL;
      });
    }
    const fileList = await base64ListToFileList(imageList || []);
    const mediaIDs: string[] = [];
    if (newUploadedImages.length > 0 && Array.isArray(fileList)) {
      await Promise.all(
        Array.from(fileList).map(async (file, index) => {
          const image = newUploadedImages[index] as UploadedFile;
          const mimeType = getFileMimeType(image.name);
          const payload: RegisterMediaPayload = { files: [{ filename: image.name, mimetype: mimeType }] };
          try {
            const registeredMedia = await registerOneReportMedia(payload);
            const mediaId = registeredMedia.files[0].upload_id;
            await fetch(registeredMedia.files[0].upload_url, {
              method: 'PUT',
              body: file,
              headers: { 'content-type': mimeType },
            });
            await confirmOneReportMedia(mediaId);
            mediaIDs.push(mediaId);
          } catch (error: unknown) {
            displayErrorDetails(error);
          }
        }),
      );
    }
    if (existingImages.length > 0) {
      const mediaIDsFromExistingImages = existingImages.map((image) => image.media_id);
      mediaIDs.push(...(mediaIDsFromExistingImages as string[]));
    }
    return mediaIDs;
  };

  const mapMediaToInsuranceMedia = (media: string[], type: string): InsuranceMedia[] => {
    return media.map((mediaId) => ({ media_id: mediaId, type }));
  };

  const [showInsuranceModal, setShowInsuranceModal] = useState<{ isOpen: boolean; verificationType: string }>({
    isOpen: false,
    verificationType: '',
  });

  const initSquare = async (): Promise<void> => {
    const squareDiv = document.getElementById('card-container');
    if (!squareDiv || !window.Square) throw new Error('Square.js failed to load properly');

    const payments = window.Square.payments(appId, locationId);
    try {
      const paymentCard = await payments.card();
      if (squareDiv.childNodes.length === 0) {
        await paymentCard.attach('#card-container');
      }
      setCard(paymentCard);
      paymentCard.addEventListener('errorClassAdded', () => setDisablePaymentButton(true));
      paymentCard.addEventListener('errorClassRemoved', () => setDisablePaymentButton(false));
    } catch (error: unknown) {
      displayErrorDetails(error);
    }
  };

  useEffect(() => {
    const initialize = async () => {
      if (displaypaymentOption === 'Self pay') {
        await initSquare();
        setPaymentStatus('');
      }
    };
    initialize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [displaypaymentOption]);

  useEffect(() => {
    const selectedCarrierId = values.find((item) => item.form_question_id === 14)?.value?.selectedCarrier;
    const selectedInsurancePlanId = values.find((item) => item.form_question_id === 14)?.value?.selectedInsurancePlan;
    let selectedCarrier = 0;

    if (selectedCarrierId !== undefined && Number(selectedCarrierId) !== 0) {
      selectedCarrier =
        insuranceCarrierOptions.find((carrier) => carrier.value === Number(selectedCarrierId))?.value || 0;
      setPatientForm({ ...patientForm, insurance_carrier_id: selectedCarrier });
    }
    if (selectedCarrier !== 0 && selectedInsurancePlanId !== undefined && Number(selectedInsurancePlanId) !== 0) {
      setPatientForm({ ...patientForm, insurance_carrier_id: selectedCarrier });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values]);

  const displayPaymentOptionFunction = (): void => {
    // If credits selected on the selection step, persist and go straight to Confirm
    if (paymentMethod === CREDITS_OPTION) {
      const remainingAfter = creditsRemaining === Infinity ? Infinity : Math.max((creditsRemaining as number) - 1, 0);

      const payload = [...values];
      const filtered = payload.filter((i) => i.form_question_id !== 19);
      filtered.push({
        form_question_id: 19,
        value: {
          paymentId: '',
          insuranceId: '',
          secondaryInsuranceId: '',
          addSecondaryInsurance,
          dataWithUpdatedInsurance: undefined,
          medicaidAnswer: '',
          payWithCredit: true,
          plan_payment: {
            method: 'CREDIT',
            use_credit: true,
            remaining_after: remainingAfter,
          },
        },
      });
      dispatch(setForm(filtered));
      navigateAfterPaymentSave(savedVerificationCode ? (savedVerificationCode as VerificationType) : undefined);
      return;
    }

    setDisplayPaymentOption(paymentMethod);
  };

  const onSubmit = async (data: PatientFormFiveSubmit): Promise<void> => {
    setDisablePaymentButton(true);

    const usingCredits = paymentMethod === CREDITS_OPTION;

    // existing vars
    let paymentId;
    let insuranceId;
    let secondaryInsuranceId;
    let dataWithUpdatedInsurance;
    let dataWithUpdatedSecondaryInsurance;

    // INSURANCE FLOW
    if (
      !usingCredits &&
      paymentMethod === 'Pay with insurance' &&
      data.insurance_through !== 'none' &&
      !isOtherCarrierIdIsSelected
    ) {
      const insuranceArray: Insurance[] = [];
      let front_of_card_media_ids: string[] = [];
      let back_of_card_media_ids: string[] = [];

      await Promise.all([
        (front_of_card_media_ids = await uploadMedia(data.front_of_card)),
        (back_of_card_media_ids = await uploadMedia(data.back_of_card)),
      ]);
      dataWithUpdatedInsurance = updateDataInsuranceNewDesign(data);
      (dataWithUpdatedInsurance as Insurance).front_of_card = mapMediaToInsuranceMedia(
        front_of_card_media_ids,
        'front_of_card',
      );
      (dataWithUpdatedInsurance as Insurance).back_of_card = mapMediaToInsuranceMedia(
        back_of_card_media_ids,
        'back_of_card',
      );
      insuranceArray.push(dataWithUpdatedInsurance as Insurance);

      if (addSecondaryInsurance) {
        let secondary_front_of_card_media_ids: string[] = [];
        let secondary_back_of_card_media_ids: string[] = [];
        await Promise.all([
          (secondary_front_of_card_media_ids = await uploadMedia(data.secondary_front_of_card)),
          (secondary_back_of_card_media_ids = await uploadMedia(data.secondary_back_of_card)),
        ]);
        dataWithUpdatedSecondaryInsurance = updateDataSecondaryInsuranceNewDesign(data);
        (dataWithUpdatedSecondaryInsurance as Insurance).front_of_card = mapMediaToInsuranceMedia(
          secondary_front_of_card_media_ids,
          'front_of_card',
        );
        (dataWithUpdatedSecondaryInsurance as Insurance).back_of_card = mapMediaToInsuranceMedia(
          secondary_back_of_card_media_ids,
          'back_of_card',
        );
        insuranceArray.push(dataWithUpdatedSecondaryInsurance as Insurance);
      }

      const updatedUserInsurance = await createPatientInsurance({
        user_id: isStaffPatientFlow
          ? Number(selectedPatient?.value)
          : Number(selectedPatient?.value) !== Number(userInfo.id)
          ? Number(selectedPatient?.value)
          : undefined,
        insurance: insuranceArray,
      });
      insuranceId = updatedUserInsurance.find((i) => !i.is_secondary)?.id || undefined;
      if (addSecondaryInsurance) secondaryInsuranceId = updatedUserInsurance.find((i) => i.is_secondary)?.id;

      dispatch(
        setUser({
          userInfo: {
            ...userInfo,
            patient_profile: {
              ...userInfo.patient_profile,
              insurance: updatedUserInsurance,
            },
          },
        }),
      );
    }

    // SELF PAY
    if (
      !usingCredits &&
      card &&
      paymentMethod === 'Self pay' &&
      (currentOrganizationPrices
        .find((pricing: Pricings) => pricing.case_types.includes(caseTypeValue))
        ?.payment_options?.find((paymentOption: string) => paymentOption === 'Credit Card') ||
        checkAllowAddingPaymentOrofileId() ||
        selfPayAllowedForCaseType)
    ) {
      const paymentProfileOwnerUserId =
        userInfo.role.name === UserRoleName.Collector || userInfo.role.name === UserRoleName.CareAdvisor
          ? Number(currentPatient?.id)
          : userInfo.role.name === UserRoleName.Admin ||
            userInfo.role.name === UserRoleName.SuperAdmin ||
            userInfo.role.name === UserRoleName.OrganizationAdmin
          ? Number(currentPatient.role.name === 'Dependent' ? currentPatient?.guardian_id : currentPatient?.id)
          : undefined;

      try {
        if (userInfo.role.name === UserRoleName.Collector || userInfo.role.name === UserRoleName.CareAdvisor) {
          const targetUserId = Number(currentPatient?.id);
          if (!currentPatient?.id || Number.isNaN(targetUserId)) {
            setCollectTargetUserError('Select a patient before adding a payment method.');
            setDisablePaymentButton(false);
            return;
          }
        }
        const tokenResult = await tokenizeAndVerifyBillingPostalCode(
          card,
          resolveBillingPostalCode(data, userInfo, isSameAddress, dependentAddress, Number(currentPatient?.id)),
        );
        if (tokenResult.status === 'OK') {
          const dataWithUpdatedPayment = updateDataPayment(
            data,
            tokenResult,
            userInfo,
            isSameAddress,
            dependentAddress,
            Number(currentPatient?.id),
            paymentProfileOwnerUserId,
          );
          const res = await addPaymentProfile(dataWithUpdatedPayment as PaymentProfile, userInfo.role.name);
          paymentId = res.id!;
        } else {
          toast.error('Please Enter your Credit Card information correctly');
          return;
        }
      } catch (error: unknown) {
        displayErrorDetails(error);
        return;
      } finally {
        setDisablePaymentButton(false);
      }
    }

    // analytics (kept)
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push({ event: 'purchase', userId: userInfo.id, paymentMethod, paymentStatus });

    setPatientForm(data);
    dispatch(
      setPatientMyProfile({
        ...(data as PatientFormFiveSubmit),
        patientId: isStaffPatientFlow ? Number(selectedPatient?.value) : userInfo?.id,
      }),
    );

    // Persist selection in Q19 — include credit flags when using credits, otherwise mark explicit false
    const payload = [...values!];
    const filteredPayload = payload.filter((item) => item.form_question_id !== 19);
    const remainingAfter = creditsRemaining === Infinity ? Infinity : Math.max((creditsRemaining as number) - 1, 0);

    const q19Value = {
      paymentId: paymentId ?? '',
      insuranceId: insuranceId ?? '',
      secondaryInsuranceId: secondaryInsuranceId ?? '',
      addSecondaryInsurance,
      dataWithUpdatedInsurance,
      medicaidAnswer: (data as any).state_funded_coverage_status ?? '',
      ...(usingCredits
        ? {
            payWithCredit: true,
            creditsRemainingAfter: remainingAfter,
            plan_payment: {
              method: 'CREDIT',
              use_credit: true,
              remaining_after: remainingAfter,
            } as any,
          }
        : {
            // 👇 Explicitly persist that credits were NOT used
            payWithCredit: false,
          }),
    };
    filteredPayload.push({
      form_question_id: 19,
      value: q19Value,
    });
    dispatch(setForm(filteredPayload));

    // Route
    if (usingCredits) {
      return navigateAfterPaymentSave(savedVerificationCode ? (savedVerificationCode as VerificationType) : undefined);
    }

    if (paymentMethod === 'Pay with insurance' && !(casePrice === 0 && currentOrganization.collect_insurance_info)) {
      testInsuranceVerification(
        dataWithUpdatedInsurance as Insurance,
        dataWithUpdatedSecondaryInsurance as Insurance | undefined,
        insuranceId,
        secondaryInsuranceId,
        q19Value,
      );
    } else {
      navigateAfterPaymentSave(savedVerificationCode ? (savedVerificationCode as VerificationType) : undefined);
    }

    setDisablePaymentButton(false);
  };

  const isSubmitDisabled = !(isOtherCarrierIdIsSelected && paymentMethod === 'Pay with insurance')
    ? disablePaymentButton ||
      (paymentMethod === 'Self pay' && billingAddress === '') ||
      userInfo.status.toLowerCase() !== 'active' ||
      loading
    : false;

  // "Current address" is only a valid billing-address choice when there's an
  // actual address on file — otherwise the option renders as literal
  // "undefined, undefined, undefined undefined" and would still let the
  // patient submit a payment profile with no real billing address.
  const activeAddressForBilling =
    userInfo.id === Number(selectedPatient?.value) ? currentPatient?.address : dependentAddress;
  const hasCompleteCurrentAddress = !!(
    activeAddressForBilling?.address1 &&
    activeAddressForBilling?.city &&
    activeAddressForBilling?.state &&
    activeAddressForBilling?.zip_code
  );
  const availableBillingAddressOptions = billingAddressOptions.filter(
    (element) => element !== 'Current address' || hasCompleteCurrentAddress,
  );

  useEffect(() => {
    if (!hasCompleteCurrentAddress && billingAddress !== 'Use a different billing address') {
      setBillingAddress('Use a different billing address');
      setIsSameAddress(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasCompleteCurrentAddress]);

  return (
    <Container
      isVisibleOnMobile
      containerStyle={{ justifyContent: screenSize.width >= 564 ? 'center' : 'start' }}
      childrenStyle={{ zIndex: '2', paddingTop: screenSize.width > 768 ? '40px' : '16px' }}
      isSidenavVisible={false}
      isIntakeProcess
    >
      <div className={styles.patientFormContainer}>
        <PatientIntakeNavigation progress={displaypaymentOption === '' ? 92 : 96} />

        {!pricesFetched ? (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '48px 0',
              minHeight: '80vh',
            }}
          >
            <Loading dotted />
          </div>
        ) : (
          <form className={styles.formContainer} onSubmit={handleSubmit(onSubmit, onInvalid)}>
            <div className={styles.wrapper}>
              {displaypaymentOption === '' && (
                <div className={styles.formContent}>
                  <span className={styles.title}>How do you want to pay?</span>

                  <div className={styles.buttonsContainer}>
                    <FormControl component="fieldset" style={{ width: '100%' }}>
                      <RadioGroup
                        name="payment-method"
                        value={paymentMethod}
                        onChange={(e) => setPaymentMethod(e.target.value)}
                        className={styles.buttonsContainer}
                      >
                        {options.map((element, index) => {
                          // Design: hide "Self pay" on selection list when credits are available
                          if (element === 'Self pay' && canShowCredits) return null;
                          const isSelected = paymentMethod === element;
                          const isDisabled =
                            element === CREDITS_OPTION ? !canShowCredits : isPaymentOptionDisabled(element);
                          const showCreditFooter = element === CREDITS_OPTION;

                          return (
                            <FormControlLabel
                              key={element}
                              value={element}
                              control={<Radio />}
                              label={
                                <div className={styles.radioLabelDiv}>
                                  <span className={styles.radioLabel}>{element}</span>

                                  {element === 'Pay with insurance' && (
                                    <>
                                      <span className={styles.radioLabelInsuranceName}>
                                        {
                                          insuranceCarrierOptions.find(
                                            (opt) => opt.value === patientForm.insurance_carrier_id,
                                          )?.label
                                        }
                                      </span>
                                      <span className={styles.radioLabelInsuranceNumber}>{patientForm.member_id}</span>
                                    </>
                                  )}

                                  {showCreditFooter && (
                                    <span className={styles.radioLabelInsuranceNumber}>
                                      {creditsRemaining === Infinity
                                        ? 'You have unlimited credits'
                                        : `You'll have ${afterThisService} ${
                                            afterThisService === 1 ? 'credit' : 'credits'
                                          } left after this service`}
                                    </span>
                                  )}
                                </div>
                              }
                              className={`fs-unmask ${styles.btn} ${isSelected ? styles.isSelectedDiv : ''}`}
                              disabled={isDisabled}
                              data-testid={`payment-information-option-label-${index}`}
                            />
                          );
                        })}
                      </RadioGroup>
                    </FormControl>
                  </div>

                  {/* Self Pay Instead – only when credits exist AND self-pay is supported */}
                  {canShowCredits && caseSupportsSelfPay && (
                    <button
                      type="button"
                      className={styles.selfPayInstead}
                      onClick={() => {
                        setPaymentMethod('Self pay');
                        setDisplayPaymentOption('Self pay');
                      }}
                    >
                      Self Pay Instead
                    </button>
                  )}
                </div>
              )}

              {displaypaymentOption !== '' ? (
                <>
                  {/* INSURANCE PANEL */}
                  <div
                    className={styles.formContent}
                    style={{ display: paymentMethod === 'Pay with insurance' ? 'flex' : 'none' }}
                  >
                    <span className={styles.formContentTitle}>Primary insurance information</span>
                    {currentOrganization.credit_card_required && (
                      <span className={`fs-unmask ${styles.insuranceText}`}>
                        We will process the below insurance information. Please be aware that you might get asked to pay
                        part of, or the full amount of the consultation cost.
                      </span>
                    )}

                    <div className={styles.insuranceWrapper}>
                      <MuiToggle
                        label="Do you currently have insurance coverage through a state-funded program such as Medicaid?"
                        options={[
                          { value: 'yes', label: 'Yes' },
                          { value: 'no', label: 'No' },
                          { value: 'not_sure', label: 'Not Sure' },
                        ]}
                        selectedValue={getValues('state_funded_coverage_status') as string}
                        onChange={(value: string) =>
                          setValue('state_funded_coverage_status', value, { shouldValidate: true })
                        }
                      />

                      <InsuranceFormSection
                        isSecondary={false}
                        phoneInputRef={phoneInputRef}
                        register={register}
                        errors={errors}
                        setValue={setValue}
                        watch={watch}
                        getValues={getValues}
                        handleChange={handleChange}
                        handleDragOver={handleDragOver}
                        handleDrop={handleDrop}
                        handleDragEnter={handleDragEnter}
                        handleDragLeave={handleDragLeave}
                        isDragging={isDragging}
                        deleteMedia={deleteMedia}
                        images={images}
                        isFromPatientIntake
                        otherInsuranceId={otherInsuranceId}
                      />

                      {Number(getValues('insurance_carrier_id')) !== otherInsuranceId && (
                        <>
                          {addSecondaryInsurance && (
                            <InsuranceFormSection
                              isSecondary={addSecondaryInsurance}
                              phoneInputRef={phoneInputRef}
                              register={register}
                              errors={errors}
                              setValue={setValue}
                              watch={watch}
                              getValues={getValues}
                              handleChange={handleChange}
                              handleDragOver={handleDragOver}
                              handleDrop={handleDrop}
                              handleDragEnter={handleDragEnter}
                              handleDragLeave={handleDragLeave}
                              isDragging={isDragging}
                              deleteMedia={deleteMedia}
                              isFromPatientIntake
                              images={images}
                            />
                          )}

                          <button
                            type="button"
                            className={styles.addSecondaryInsuranceButton}
                            onClick={() => {
                              if (
                                addSecondaryInsurance &&
                                currentPatientInsurance &&
                                currentPatientInsurance.length > 0
                              ) {
                                const insurance = currentPatientInsurance.find((i) => i.is_secondary);

                                if (insurance) {
                                  removeSecondaryInsurance(Number(insurance.id));
                                }
                              } else if (addSecondaryInsurance && currentPatientInsurance?.[1] === undefined) {
                                const secondaryPrefix = 'secondary_';
                                Object.keys(getValues()).forEach((key) => {
                                  if (key.startsWith(secondaryPrefix)) {
                                    setValue(key as keyof PatientFormFiveSubmit, undefined);
                                  }
                                });

                                setImages((prev) => ({
                                  ...prev,
                                  secondary_front_of_card: [],
                                  secondary_back_of_card: [],
                                }));
                              }
                              setAddSecondaryInsurance(!addSecondaryInsurance);
                            }}
                            data-testid="add-secondary-insurance"
                          >
                            {!addSecondaryInsurance ? (
                              <>
                                <FiPlus className={styles.addIcon} /> Add Secondary Insurance
                              </>
                            ) : (
                              <>
                                <FiMinus className={styles.addIcon} /> Remove Secondary Insurance
                              </>
                            )}
                          </button>
                        </>
                      )}
                    </div>
                  </div>

                  {/* SELF PAY PANEL */}
                  <div
                    className={styles.formContent}
                    style={{ display: paymentMethod === 'Self pay' ? 'flex' : 'none' }}
                  >
                    <span className={styles.paymentInfoTitle}>Confirm payment details</span>

                    <div className={`row ${styles.row}`}>
                      <div className="col-md-12">
                        <div className={styles.inputWrap}>
                          <TextField
                            {...register('creditCardFullName')}
                            data-testid="complete-profile-last_name"
                            label="Name as it appears on card"
                            errors={errors.creditCardFullName ? errors : {}}
                            name="creditCardFullName"
                            onChange={(e) => {
                              setValue('creditCardFullName', e.target.value, { shouldValidate: true });
                              setPatientForm((prev) => ({ ...prev, creditCardFullName: e.target.value }));
                            }}
                            required
                            inputClass={`${styles.profileInputClass} fs-exclude`}
                            wrapperClassName={`fs-unmask ${styles.completeProfileClass}`}
                          />
                        </div>
                      </div>
                    </div>

                    <div className={`row ${styles.creditCardContainer} p-row`}>
                      <div>
                        <span
                          style={{ opacity: '0.5', fontSize: '16px' }}
                          className={`fs-unmask ${styles.creditCardIconsText}`}
                        >
                          Credit Card Information
                        </span>
                        <span style={{ color: '#FA5151' }}> *</span>
                      </div>

                      <div id="form-container">
                        <div
                          id="card-container"
                          className="fs-exclude"
                          style={{ maxHeight: '80px' }}
                          data-testid="payment-information-card-container"
                          ref={cardContainerRef}
                        />
                        <span>{paymentStatus}</span>
                        <div className={`${styles.invalidFeedback} invalid-feedback`}>
                          {errors.creditCardNumber?.message}
                        </div>
                        {userInfo.role.name === UserRoleName.Collector && collectTargetUserError && (
                          <div
                            className={styles.invalidFeedback}
                            role="alert"
                            data-testid="collector-target-user-error"
                          >
                            {collectTargetUserError}
                          </div>
                        )}

                        <span className={styles.creditCardIconsText} data-testid="payment-information-we-accept">
                          We accept
                        </span>
                        <div className={styles.creditCardIcons}>
                          <span>
                            <img src={visa} alt="Visa" />
                          </span>
                          <span>
                            <img src={masterCard} alt="MasterCard" />
                          </span>
                          <span>
                            <img src={amex} alt="AMEX" />
                          </span>
                          <span>
                            <img src={disCover} alt="DisCover" />
                          </span>
                          <span>
                            <img src={jcb} alt="JCB" />
                          </span>
                          <span>
                            <img src={unionPay} alt="UnionPay" />
                          </span>
                          <span>
                            <img src={hsa} alt="HSA" />
                          </span>
                          <span>
                            <img src={fsa} alt="FSA" />
                          </span>
                        </div>
                      </div>
                    </div>

                    <span className={`fs-unmask ${styles.subTitle}`}>
                      Billing Address <span style={{ color: '#FA5151' }}> *</span>
                    </span>

                    <div className={styles.buttonsContainer} style={{ paddingTop: '0', marginTop: '-20px' }}>
                      <FormControl component="fieldset" style={{ width: '100%' }}>
                        <RadioGroup
                          name="billing-address"
                          value={billingAddress}
                          onChange={(e) => {
                            setBillingAddress(e.target.value);
                            setIsSameAddress(e.target.value !== 'Current address');
                          }}
                          className={styles.buttonsContainer}
                        >
                          {availableBillingAddressOptions.map((element, index) => {
                            const isSelected = billingAddress === element;
                            return (
                              <div
                                key={element}
                                className={`fs-exclude ${styles.btn} ${isSelected ? styles.isSelectedDiv : ''}`}
                                data-testid={`billing-address-information-option-wrapper-${index}`}
                              >
                                <FormControlLabel
                                  value={element}
                                  control={
                                    <Radio
                                      inputProps={
                                        {
                                          'data-testid': `radio-input-${index}`,
                                        } as React.InputHTMLAttributes<HTMLInputElement>
                                      }
                                    />
                                  }
                                  label={
                                    <div className={styles.radioLabelDiv}>
                                      {element !== 'Current address' ? (
                                        <span className={styles.radioLabelAddress}>{element}</span>
                                      ) : (
                                        <span className={`fs-exclude  ${styles.radioLabelAddress}`}>
                                          {userInfo.id === Number(selectedPatient?.value)
                                            ? `${currentPatient?.address?.address1}, ${currentPatient?.address?.city}, ${currentPatient?.address?.state} ${currentPatient?.address?.zip_code}`
                                            : `${dependentAddress?.address1}, ${dependentAddress?.city}, ${dependentAddress?.state} ${dependentAddress?.zip_code}`}
                                        </span>
                                      )}
                                    </div>
                                  }
                                  sx={{ width: '100%', margin: 0 }}
                                />
                              </div>
                            );
                          })}
                        </RadioGroup>
                      </FormControl>
                    </div>

                    {isSameAddress && (
                      <>
                        <div className={`row ${styles.row}`}>
                          <div className="col-md-12">
                            <div className={styles.inputWrap}>
                              <TextField
                                {...register('creditCardAddress1')}
                                errors={errors}
                                name="creditCardAddress1"
                                value={getValues('creditCardAddress1')}
                                onChange={(e) =>
                                  setValue('creditCardAddress1', e.target.value, { shouldValidate: true })
                                }
                                label="Address"
                                required
                                wrapperStyle={{ marginTop: '0', height: '100%', borderBottom: 'none' }}
                                wrapperClassName="fs-exclude"
                                inputClass={styles.profileInputClass}
                              />
                            </div>
                          </div>
                        </div>

                        <div className={`row ${styles.row}`}>
                          <div className="col-md-12">
                            <div className={styles.inputWrap}>
                              <TextField
                                {...register('creditCardAddress2')}
                                errors={errors}
                                name="creditCardAddress2"
                                value={getValues('creditCardAddress2')}
                                onChange={(e) =>
                                  setValue('creditCardAddress2', e.target.value, { shouldValidate: true })
                                }
                                label="Apartment, suite, etc. (optional)"
                                wrapperStyle={{ marginTop: '0', height: '100%', borderBottom: 'none' }}
                                wrapperClassName="fs-exclude"
                                inputClass={styles.profileInputClass}
                              />
                            </div>
                          </div>
                        </div>

                        <div className={`row ${styles.row}`}>
                          <div className="col-12 col-md-4">
                            <div className={styles.inputWrap}>
                              <TextField
                                {...register('creditCardCity')}
                                errors={errors}
                                name="creditCardCity"
                                value={getValues('creditCardCity')}
                                onChange={(e) => setValue('creditCardCity', e.target.value, { shouldValidate: true })}
                                label="City"
                                required
                                wrapperStyle={{ marginTop: '0', height: '100%', borderBottom: 'none' }}
                                wrapperClassName="fs-exclude"
                                inputClass={styles.profileInputClass}
                              />
                            </div>
                          </div>

                          <div className="col-12 col-md-8">
                            <div className="row">
                              <div className="col-6 col-md-6">
                                <div className={styles.inputWrap}>
                                  <MUISelectInput
                                    {...register('creditCardState')}
                                    data-testid="complete-profile-state"
                                    label="State"
                                    errors={errors.creditCardState ? errors : {}}
                                    name="creditCardState"
                                    onChange={(e: any) => {
                                      if (errors.creditCardState) clearErrors('creditCardState');
                                      setValue('creditCardState', e);
                                    }}
                                    value={watch('creditCardState') || ''}
                                    required
                                    inputClass={`${styles.profileInputClass} fs-exclude`}
                                    wrapperClassName={`fs-unmask ${styles.completeProfileClass}`}
                                    options={stateOptions}
                                  />
                                </div>
                              </div>

                              <div className="col-6 col-md-6">
                                <div className={styles.inputWrap}>
                                  <TextField
                                    {...register('creditCardZipCode')}
                                    errors={errors}
                                    name="creditCardZipCode"
                                    value={getValues('creditCardZipCode')}
                                    onChange={(e) =>
                                      setValue('creditCardZipCode', e.target.value, { shouldValidate: true })
                                    }
                                    required
                                    label="Zip Code"
                                    wrapperStyle={{ marginTop: '0', height: '100%', borderBottom: 'none' }}
                                    wrapperClassName="fs-exclude"
                                    inputClass={styles.profileInputClass}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>

                  <div className={styles.btnContainer} style={{ display: paymentMethod === '' ? 'none' : '' }}>
                    <span className={`fs-unmask ${styles.disclaimer}`}>
                      DISCLAIMER: {getCaseDisclaimer(caseTypeValue)}
                    </span>

                    <div className={styles.paymentSectionButtonDiv}>
                      <Button
                        variant="text"
                        type="button"
                        className={`fs-unmask ${styles.backBtnSticky}`}
                        onClick={() => {
                          if (enabledOptions.length === 1) {
                            navigate(-1);
                          } else {
                            setPaymentMethod('');
                            setDisplayPaymentOption('');
                          }
                        }}
                        data-testid="payment-information-back"
                      >
                        <AiOutlineLeft /> Back
                      </Button>

                      <Button
                        type="submit"
                        variant="contained"
                        className={`fs-unmask ${styles.nextBtnSticky}`}
                        disabled={isSubmitDisabled}
                        onTouchStart={
                          isMobile || mobileDetect
                            ? (e) => {
                                if (!isSubmitDisabled) {
                                  handleSubmit(onSubmit, onInvalid)();
                                } else {
                                  e.preventDefault();
                                }
                              }
                            : undefined
                        }
                        data-testid="payment-information-form-submit"
                      >
                        Next
                      </Button>
                    </div>
                  </div>
                </>
              ) : (
                <div className={styles.noSelectionButtonDiv}>
                  <Button
                    variant="text"
                    type="button"
                    className={`fs-unmask ${styles.backBtnSticky}`}
                    onClick={() => navigate(-1)}
                    data-testid="payment-information-back"
                  >
                    <AiOutlineLeft /> Back
                  </Button>
                  <Button
                    className={`fs-unmask ${styles.nextBtnSticky}`}
                    disabled={paymentMethod === ''}
                    onClick={displayPaymentOptionFunction}
                    data-testid="payment-information-next"
                  >
                    Next
                  </Button>
                </div>
              )}
            </div>

            {false && <SubmitCCConfirmationModal />}

            <InsuranceVerificationModal
              isOpen={showInsuranceModal.isOpen}
              onClose={() =>
                setShowInsuranceModal({ isOpen: false, verificationType: showInsuranceModal.verificationType })
              }
              verificationType={showInsuranceModal.verificationType as VerificationType}
              callAddOtherCarrierIdIsSelected={callAddOtherCarrierIdIsSelected}
              intakeContinueRoute={paymentPassThroughState.afterPaymentRoute}
              intakeContinueState={intakeContinueStateForModal}
            />
          </form>
        )}
      </div>
    </Container>
  );
};

export default PaymentInformation;
